document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('[data-tmj-mega-drawer]');
  const overlay = document.querySelector('[data-tmj-mega-overlay]');
  const triggers = document.querySelectorAll('[data-tmj-mega-open]');
  const closeButtons = document.querySelectorAll('[data-tmj-mega-close]');
  const categoryButtons = document.querySelectorAll('[data-tmj-category]');
  const panels = document.querySelectorAll('[data-tmj-panel]');

  if (!drawer || !overlay || !triggers.length) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    triggers.forEach(trigger => trigger.classList.add('is-active'));
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    triggers.forEach(trigger => trigger.classList.remove('is-active'));
  }

  triggers.forEach(trigger => {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();

      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', closeDrawer);
  });

  overlay.addEventListener('click', closeDrawer);

  categoryButtons.forEach(button => {
    const activateCategory = function () {
      const category = button.dataset.tmjCategory;

      categoryButtons.forEach(item => item.classList.remove('is-active'));
      panels.forEach(panel => panel.classList.remove('is-active'));

      button.classList.add('is-active');

      const activePanel = document.querySelector(`[data-tmj-panel="${category}"]`);
      if (activePanel) activePanel.classList.add('is-active');
    };

    button.addEventListener('mouseenter', activateCategory);
    button.addEventListener('click', activateCategory);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });
});
